import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	catalogues: [],
	page: 1,
	maxPage: 1,
	total: 0,
};

const cataloguesSlice = createSlice({
	name: 'catalogues',
	initialState: initialState,
	reducers: {
		setCatalogues: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setCatalogues, reset } = cataloguesSlice.actions;

export default cataloguesSlice.reducer;